/** @format */

import { ProductAvailability } from './product-availability.interface';

export interface ProductAvailabilityCollection {
  ecodeMessagingMap: {
    [key: string]: ProductAvailability;
  };
}
